import { fixFloatValue } from "../../../../../pages/components/helpers";
class SoilRepository {
  constructor(api) {
    this.api = api;
  }

  async save(farm) {
    const {
      NAME,
      TRANSMISSIVITY,
      FIELD_CAPACITY,
      WILT_POINT,
      DENSITY,
      FK_EDITOR
    } = farm;
    const raw = `
      INSERT INTO CROP.SOIL (
        NAME ,
        TRANSMISSIVITY ,
        FIELD_CAPACITY ,
        WILT_POINT ,
        DENSITY,
        FK_EDITOR
      )VALUES(
        "${NAME}",
        ${Number(TRANSMISSIVITY)},
        ${Number(FIELD_CAPACITY)},
        ${Number(WILT_POINT)},
        ${Number(DENSITY)},
        ${FK_EDITOR}
      );
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }

  async delete(id) {
    const raw = `
      DELETE FROM CROP.SOIL
      WHERE ID=${id};
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }

  async updateFkEditor(ID_SOIL, FK_EDITOR) {
    const raw = `
      UPDATE CROP.SOIL
      SET FK_EDITOR = ${FK_EDITOR}
      WHERE ID = ${ID_SOIL};
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }

  async update(farm) {
    const {
      ID,
      NAME,
      TRANSMISSIVITY,
      FIELD_CAPACITY,
      WILT_POINT,
      DENSITY,
      FK_EDITOR
    } = farm;
    const raw = `
    UPDATE CROP.SOIL
    SET NAME="${NAME}",
    TRANSMISSIVITY=${TRANSMISSIVITY},
    FIELD_CAPACITY=${FIELD_CAPACITY},
    WILT_POINT=${WILT_POINT},
    DENSITY=${DENSITY},
    FK_EDITOR =${FK_EDITOR}
    WHERE ID=${ID};
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }

  async show() {
    const raw = `
      SELECT CROP.SOIL.*,C_USER.NAME AS EDITOR_NAME FROM CROP.SOIL
      LEFT JOIN NEWSIR.CAD_USER C_USER
      ON C_USER.ID = FK_EDITOR
      WHERE CROP.SOIL.IS_ACTIVE = 1;
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }

  async getSoiIdByName(NAME) {
    const raw = `
      SELECT ID FROM CROP.SOIL WHERE NAME = "${NAME}";
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (!resp[0].length) {
      console.log("[getSoilById] Não há registros de solo");
      return {};
    }

    const soil = resp[0][0].ID;

    return soil;
  }

  async getSoilById(id) {
    const raw = `
      SELECT * FROM CROP.SOIL WHERE ID = ${id};
    `;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (!resp[0].length) {
      console.log("[getSoilById] Não há registros de solo");
      return {};
    }

    let soil = resp[0][0];

    Object.assign(soil, {
      WATER_DISPONIBILITY: this.getWaterDisponibility(soil)
    });

    return soil;
  }

  getWaterDisponibility(soil) {
    try {
      const { FIELD_CAPACITY, WILT_POINT, DENSITY } = soil ? soil : {};

      return fixFloatValue((FIELD_CAPACITY - WILT_POINT) * DENSITY * 10);
    } catch (e) {
      console.log(`[CRON getWaterDiponibility] - ${e}`);
    }
  }

  // getSoilStorage(waterDisponibility, depthRoot) {
  //   return fixFloatValue(waterDisponibility * depthRoot);
  // }
}
export { SoilRepository };
